"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getMappingsService;
function getMappingsService(client) {
	return client.performFetchRequest({
		method: "GET",
		path: "_mapping"
	});
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/appbase-js/lib/actions/get_mappings.js
// module id = 203
// module chunks = 0